<script>
    /**
     * This component is only needed for the form field components rendered inline not in an SPA context
     * We need to provide a model object, that will store and update our input field value
     */
    export default {
        props: {
            component: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                model: this.$attrs.value,
            };
        },
        render(createElement) {
            const { value, ...props } = this.$attrs; // eslint-disable-line

            return createElement(this.component, {
                props: {
                    ...props,
                    value: this.model,
                },
                on: {
                    input: val => {
                        this.model = val;
                    },
                },
            });
        },
    };
</script>
